import './style.scss';
import React from 'react';

const LeftPanel = ({ children }) => <div className="left-panel">{children}</div>;

export default LeftPanel;
